import React, { Component } from 'react';
import { Icon } from 'components/antd';

import styles from './styles.module.scss';

interface Props {
	inputValue?: string;
	flightNumber?: string;
	flightSearch?: string;

	resetInputValue: () => void;
	hideFlightNumber: () => void;
}

export default class Prefix extends Component<Props> {
	render() {
		const { flightNumber, flightSearch, inputValue } = this.props;
		if (inputValue) {
			// TODO: remove it from render
			this.props.resetInputValue();
		}
		return (
			<span>
				<span className={styles.flightNumberChips}>
					<Icon type={'plane'} />
					<span>{flightNumber}</span>
					<Icon type={'remove'} onClick={this.props.hideFlightNumber} />
				</span>
				<span className={styles.flightNumberLabel}>{flightSearch}</span>
			</span>
		);
	}
}
